export default __webpack_public_path__ + "static/media/classComp-pageload-log.c4cc1b3e.png";